export default __webpack_public_path__ + "static/media/3--.a2f13f9e.png";